import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StoreService } from '../../store.service';

@Component({
  selector: 'app-heatmap',
  templateUrl: './heatmap.component.html',
  styleUrls: ['./heatmap.component.scss'],
})
export class HeatmapComponent implements OnInit {
  bearer: string;
  storeId: string;
  sessions: any[] = [];
  isLoading = true;

  currentPage = 1;
  pageSize = 20;
  totalRecord = 0;
  totalPage = 0;
  start = 0;
  end = 0;

  DATE_FILTERS = [
    { display: 'Today', value: 'today' },
    { display: 'Yesterday', value: 'yesterday' },
    { display: 'Last 14 Days', value: 'last14' },
  ];
  selectedDateFilter = this.DATE_FILTERS[2];
  startDate: string;
  endDate: string;

  constructor(private svc: StoreService, private router: Router, private modalService: NgbModal) {}

  ngOnInit(): void {
    this.bearer  = localStorage.getItem('bearer');
    this.storeId = localStorage.getItem('store_id');
    this.applyDateFilter();
    this.loadSessions();
  }

  applyDateFilter(): void {
    const today = moment();
    if (this.selectedDateFilter.value === 'today') {
      this.startDate = today.format('YYYY-MM-DD');
      this.endDate   = today.format('YYYY-MM-DD');
    } else if (this.selectedDateFilter.value === 'yesterday') {
      const yesterday = today.clone().subtract(1, 'days');
      this.startDate  = yesterday.format('YYYY-MM-DD');
      this.endDate    = yesterday.format('YYYY-MM-DD');
    } else {
      this.startDate = today.clone().subtract(13, 'days').format('YYYY-MM-DD');
      this.endDate   = today.format('YYYY-MM-DD');
    }
  }

  loadSessions(): void {
    this.isLoading = true;
    this.svc.getAnalyticsSessions(this.bearer, this.storeId, this.currentPage, this.pageSize, this.startDate, this.endDate).subscribe(
      (res) => {
        this.sessions = res?.data?.data ?? [];
        const pagination = res?.data?.pagination;
        if (pagination) {
          this.currentPage  = pagination.page;
          this.totalRecord  = pagination.total_record;
          this.totalPage    = pagination.total_page;
        }
        this.start     = (this.currentPage - 1) * this.pageSize;
        this.end       = this.start + this.sessions.length;
        this.isLoading = false;
      },
      () => { this.isLoading = false; }
    );
  }

  openFilter(content: any): void {
    this.modalService.open(content, {
      windowClass: 'modal-filter-container',
      backdropClass: 'modal-filter-backdrop',
      animation: false,
    });
  }

  selectDateFilter(filter: { display: string; value: string }): void {
    this.selectedDateFilter = filter;
    this.currentPage = 1;
    this.applyDateFilter();
    this.loadSessions();
  }

  onPageChange(): void {
    this.loadSessions();
  }

  viewHeatmap(sessionId: string): void {
    this.router.navigate(['/dashboard/replay/heatmap', sessionId]);
  }

  formatDuration(ms: number): string {
    if (!ms) { return '-'; }
    const s = Math.floor(ms / 1000);
    const m = Math.floor(s / 60);
    const h = Math.floor(m / 60);
    if (h > 0) {
      return `${h}h ${m % 60}m ${s % 60}s`;
    }
    return m > 0 ? `${m}m ${s % 60}s` : `${s}s`;
  }

  shortId(id: string): string {
    return id ? id.split('-')[0] : '-';
  }
}
